import { jsx } from 'react/jsx-runtime';
import AppContextProvider from './AppContextProvider.js';
import themeStyles from '../styles/themes.module.scss.js';
import OverlaysProvider from './OverlaysProvider.js';

const Providers = ({ children, shopBundle, domain, locale, csrfToken, }) => {
    return (jsx("div", { className: themeStyles[shopBundle], children: jsx(AppContextProvider, { value: { shopBundle, locale, domain, csrfToken }, children: jsx(OverlaysProvider, { children: children }) }) }));
};

export { Providers as default };
//# sourceMappingURL=Providers.js.map
